import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        isExpanded: true
    }
};
export default createReducer(initialState, {
    [actionTypes.SET_IS_EXPANDED]: (state, { isExpanded }) => set(state, `[${NAMESPACE}].isExpanded`, isExpanded)
});
